/**
 * Send request to the Stops api.
 * @param {*} store The redux store.
 * @param {*} params An object with serializable data to send to the stop api.
 * @param {*} abortController An abortController to abort the request.
 * @returns A Promise with the response from the stop api.
 */
const fetchStations = (store, params, abortController) => {
  const { stopFinderKey, stopFinderUrl } = store.getState().app;
  const searchParams = new URLSearchParams(params);
  searchParams.set("key", stopFinderKey);
  const url = new URL(`${stopFinderUrl}?${searchParams.toString()}`);
  return fetch(url.toString(), {
    signal: abortController.signal,
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.error) {
        throw new Error(data.error);
      }
      return data;
    });
};

export default fetchStations;
